import styled from "styled-components";

export const TextAreaContainer = styled.textarea`
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.bg.primary};
  border-radius: 8px;
  box-sizing: border-box;
  border: none;
  width: 100%;
  resize: vertical;

  &:focus {
    outline: ${({ theme }) => `2px solid ${theme.text.brand}4d`};
    outline-offset: 1px;
    background-color: ${({ theme }) => theme.bg.general};
  }
`;
